import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Blogbody.css";
import { Link } from "react-router-dom";

const BlogPage = ({ blogs }) => {
  if (!blogs || blogs.length === 0) {
    return (
      <div
        className="container mt-5"
        style={{
          maxWidth: "100%",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <img src="/images/not-found.png" alt="Not Found" />
      </div>
    );
  }

  return (
    <>
      <title>Blog Page</title>

      <div className="container mt-5">
        <div className="row">
          {blogs.map((blog, index) => (
            <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={index}>
              <div className="card h-100 shadow-sm">
                <img
                  src={blog.blog_image?.url}
                  className="card-img-top"
                  alt={blog.title}
                  onError={(e) => e.target.src = "/images/fallback.jpg"} // fallback image if not found
                />
                <div className="card-body d-flex flex-column">
                  <h5 className="card-title">{blog.title}</h5>
                  <p className="card-text">
                    {blog?.description.split(" ").slice(0, 20).join(" ") + "..."}
                    </p>
                  <p className="card-meta text-muted">
                    {new Date(blog.publishedAt).toLocaleDateString()} |{" "}
                    {blog.author?.name}
                  </p>
                </div>
                <Link
                  to={`/blogs/${blog.slug}`}
                  state={blog}
                  className="btn btn-primary m-2"
                >
                  Read More
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BlogPage;
